import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import craneImg from "../../../Assets/Crane.png";
import recoveryImg from "../../../Assets/RecoveryVan.png";
import accidentImg from "../../../Assets/Accident.png";
import mechanicImg from "../../../Assets/Mechanic.png";
import legalImg from "../../../Assets/advocate.png";
import inspectionImg from "../../../Assets/vehicleInspection.png";
import challanImg from "../../../Assets/Challan.png";

const services = [
  { title: "Crane Assistance", image: craneImg, accent: "#21A6E9" },
  { title: "Recovery Vans", image: recoveryImg, accent: "#00B3A4" },
  { title: "Accident Support", image: accidentImg, accent: "#FF6B35" },
  { title: "Mechanical Assistance", image: mechanicImg, accent: "#00C896" },
  { title: "Advocate Services", image: legalImg, accent: "#7B61FF" },
  { title: "Vehicle Inspection", image: inspectionImg, accent: "#F5A623" },
  { title: "Challan Assistance", image: challanImg, accent: "#E63946" },
];

export default function CinematicServices() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % services.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const service = services[index];

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">

      {/* Background Image */}
      <AnimatePresence mode="wait">
        <motion.img
          key={service.image}
          src={service.image}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Accent Gradient */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background: `radial-gradient(circle at center, ${service.accent}, transparent 60%)`,
        }}
      />

     <div className="absolute top-24 w-full text-center px-6">

  <motion.h2
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    className="text-5xl md:text-7xl font-semibold tracking-tight
               bg-gradient-to-r from-white via-gray-200 to-gray-400
               bg-clip-text text-transparent
               drop-shadow-[0_5px_20px_rgba(0,0,0,0.8)]"
  >
    Our Complete Assistance Ecosystem
  </motion.h2>

  <p className="text-gray-300 mt-8 max-w-2xl mx-auto text-lg leading-relaxed">
    From accident recovery to legal closure — ClaimPro delivers a full
    technology-enabled support system for commercial vehicles.
  </p>

</div>

      {/* Service Title */}
      <div className="absolute bottom-32 w-full text-center">
        <motion.h3
          key={service.title}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
className="text-5xl md:text-7xl font-semibold tracking-tight 
bg-gradient-to-r from-white via-gray-200 to-gray-400 
bg-clip-text text-transparent drop-shadow-[0_5px_20px_rgba(0,0,0,0.7)]"
        >
          {service.title}
        </motion.h3>
      </div>

    </section>
  );
}
